var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"annotation",staticClass:"annotation",attrs:{"id":_vm.annotation.id}},[(!_vm.publicView)?_c('span',{ref:"contentEditable",class:[
      'annotation-value',
      _vm.isLoading && 'saving-changes',
      _vm.showActionError &&
        _vm.editAnnotation &&
        _vm.editAnnotation.id === _vm.annotation.id &&
        'error-editing',
      _vm.isAnnotationBeingEdited && 'clicked',
    ],attrs:{"id":_vm.annotation.id,"role":"textbox","contenteditable":_vm.isAnnotationBeingEdited},on:{"click":_vm.handleEditAnnotation,"paste":_vm.handlePaste,"keypress":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter"))return null;return _vm.saveAnnotationChanges.apply(null, arguments)}}},[_vm._v(" "+_vm._s(_vm.span.offset_string)+" ")]):_c('span',{staticClass:"annotation-value"},[_vm._v(" "+_vm._s(_vm.span.offset_string)+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }